import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigMap } from './formly-field-config.map';
import { FormlyUtil } from '../formly.util';
import {ItemLocale} from '@emm/core/models/locale.model';
import {ItemAttributeType} from '@emm/core/models/enums';

const labelWithLocale = ({ name, metadata: { localeSupport }, values }) => {
    const { country, language } = values[0];
    if (country === 'US' && !localeSupport || !language) {
        return `${name}`;
    }
    return `${name} (${language}-${country})`;
};

const isRequiredByLocale = (values, language) => {
    const { country } = values[0];
    return (country === 'US' || !language);
};

const isOverrideExpression = (model: any, formState: any, field: FormlyFieldConfig): boolean => {
    return model[field?.key as string];
};

export const itemsFormFieldMap: FormlyFieldConfigMap<ItemLocale> = {



    [ItemAttributeType.Text]: (attribute: ItemLocale, index: number, isReadOnly: boolean, language: string) => ({
            expressionProperties: {
                'templateOptions.isOverride': isOverrideExpression
            },
            key: attribute.tag,
            templateOptions: {
                appearance: 'fill',
                description: attribute.description,
                label: labelWithLocale(attribute),
                maxLength: 512,
                readonly: isReadOnly || attribute.metadata.readOnly,
                required: attribute.metadata.required && isRequiredByLocale(attribute.values, language),
                tooltip: attribute.auditInfo
            },
            type: 'input',
            wrappers: ['form-field-horizontal']
        }
    ),



    [ItemAttributeType.TextArea]: (attribute: ItemLocale, index: number, isReadOnly: boolean, language: string) => ({
        expressionProperties: {
            'templateOptions.isOverride': isOverrideExpression
        },
        key: attribute.tag,
        templateOptions: {
            appearance: 'fill',
            description: attribute.description,
            label: labelWithLocale(attribute),
            maxLength: 512,
            readonly: isReadOnly || attribute.metadata.readOnly,
            required: attribute.metadata.required && isRequiredByLocale(attribute.values, language),
            rows: 3,
            tooltip: attribute.auditInfo
        },
        type: 'textarea-autosize',
        wrappers: ['form-field-horizontal'],
    }),



    [ItemAttributeType.Number]: (attribute: ItemLocale, index: number, isReadOnly: boolean, language: string) => ({
        expressionProperties: {
            'templateOptions.isOverride': isOverrideExpression
        },
        key: attribute.tag,
        templateOptions: {
            appearance: 'fill',
            description: attribute.description,
            label: labelWithLocale(attribute),
            maxLength: 512,
            readonly: isReadOnly || attribute.metadata.readOnly,
            required: attribute.metadata.required && isRequiredByLocale(attribute.values, language),
            tooltip: attribute.auditInfo,
            type: 'number'
        },
        type: 'input',
        wrappers: ['form-field-horizontal']
    }),



    [ItemAttributeType.Boolean]: (attribute: ItemLocale, index: number, isReadOnly: boolean, language: string) => ({
        expressionProperties: {
            'templateOptions.isOverride': isOverrideExpression
        },
        key: attribute.tag,
        templateOptions: {
            appearance: 'fill',
            description: attribute.description,
            label: labelWithLocale(attribute),
            options: [...FormlyUtil.getBooleanList(attribute.metadata.required)],
            readonly: isReadOnly || attribute.metadata.readOnly,
            required: attribute.metadata.required && isRequiredByLocale(attribute.values, language),
            tooltip: attribute.auditInfo
        },
        type: 'select',
        wrappers: ['form-field-horizontal']
    }),



    [ItemAttributeType.Select]: (attribute: ItemLocale, index: number, isReadOnly: boolean, language: string) => ({
        expressionProperties: {
            'templateOptions.isOverride': isOverrideExpression
        },
        key: attribute.tag,
        templateOptions: {
            appearance: 'fill',
            description: attribute.description,
            label: labelWithLocale(attribute),
            options: [...attribute.metadata.options],
            readonly: isReadOnly || attribute.metadata.readOnly,
            required: attribute.metadata.required && isRequiredByLocale(attribute.values, language),
            tooltip: attribute.auditInfo
        },
        type: 'select',
        wrappers: ['form-field-horizontal']
    }),



    [ItemAttributeType.MultiSelect]: (attribute: ItemLocale, index: number, isReadOnly: boolean, language: string) => ({
        expressionProperties: {
            'templateOptions.isOverride': isOverrideExpression
        },
        key: attribute.tag,
        templateOptions: {
            appearance: 'fill',
            description: attribute.description,
            label: labelWithLocale(attribute),
            multiple: true,
            options: [...attribute.metadata.options],
            placeholder: 'Select',
            readonly: isReadOnly || attribute.metadata.readOnly,
            required: attribute.metadata.required && isRequiredByLocale(attribute.values, language),
            selectAllOption: 'Select All',
            tooltip: attribute.auditInfo
        },
        type: 'select',
        wrappers: ['form-field-horizontal']
    }),


    [ItemAttributeType.Image]: (attribute: ItemLocale, index: number, isReadOnly: boolean, language: string) => ({
            expressionProperties: {
                'templateOptions.isOverride': isOverrideExpression
            },
            key: attribute.tag,
            templateOptions: {
                appearance: 'fill',
                description: attribute.description,
                label: labelWithLocale(attribute),
                maxLength: 512,
                readonly: isReadOnly || attribute.metadata.readOnly,
                required: attribute.metadata.required && isRequiredByLocale(attribute.values, language),
                tooltip: attribute.auditInfo
            },
            type: 'input',
            wrappers: ['form-field-horizontal']
        }
    ),



};
